import React, { useEffect, useState } from "react";
import { Table, Select, Button, Modal, Form, Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  pressureSoreAreaOptions,
  pressureSoreGradeOptions,
} from "../../../../Options/systemicExamOptions";

const PressureSore = ({ pressureSore, setPressureSore }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  // ✅ Watch area field — triggers re-render when value changes
  const selectedArea = Form.useWatch("area", form);

  const handleAddPressureSore = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const newData = pressureSore
          ? [...pressureSore, { ...values, key: pressureSore.length }]
          : [{ ...values, key: 0 }];
        setPressureSore(newData);
        form.resetFields();
        setIsModalVisible(false);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
  };

  useEffect(() => {
    form.setFieldsValue({
      ...pressureSore,
    });
  }, [pressureSore, form]);

  const columns = [
    {
      title: "Area",
      dataIndex: "area",
      key: "area",
      render: (text, record) =>
        text !== "others"
          ? pressureSoreAreaOptions.find((option) => option.value === text)
              ?.label
          : record?.other_sore,
    },
    {
      title: "Grade",
      dataIndex: "grade",
      key: "grade",
      render: (text) =>
        pressureSoreGradeOptions.find((option) => option.value === text)?.label,
    },
  ];

  return (
    <div>
      <Form.Item label="Pressure Sore">
        <Button
          onClick={handleAddPressureSore}
          type="primary"
          style={{ marginBottom: 16 }}
        >
          <PlusOutlined /> Add Row
        </Button>
        <Table columns={columns} dataSource={pressureSore} pagination={false} />
        <Modal
          title="Add Pressure Sore"
          open={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          okText="Add Row"
          cancelText="Close"
        >
          <Form form={form} layout="vertical">
            <Form.Item
              name="area"
              label="Area"
              rules={[{ required: true, message: "Please select an area!" }]}
            >
              <Select
                placeholder="Select Area"
                options={pressureSoreAreaOptions}
                style={{ width: "100%" }}
              />
            </Form.Item>

            {/* ✅ Use selectedArea instead of form.getFieldValue */}
            {selectedArea === "others" && (
              <Form.Item
                name="other_sore"
                label="Other Pressure Sore Area"
                rules={[
                  {
                    required: true,
                    message: "Please enter other pressure sore area",
                  },
                ]}
              >
                <Input style={{ width: "240px" }} />
              </Form.Item>
            )}

            <Form.Item
              name="grade"
              label="Grade"
              rules={[{ required: true, message: "Please select a grade!" }]}
            >
              <Select
                placeholder="Select Grade"
                options={pressureSoreGradeOptions}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Form>
        </Modal>
      </Form.Item>
    </div>
  );
};

export default PressureSore;
